import { DateFormat, formatDate, isAllDay as isAllDayExperience } from "common";
import dayjs from "dayjs";
import { BaseScheduleRepeat, BaseScheduleType, Event, Experience, ScheduleDeparture, Timeslot } from "types";
import { getBlackoutTimeRanges, isAllDay } from "../../models/Event";

interface GetBlackoutSchedulePayloadProps {
    timeslot?: Timeslot;
    event?: Event;
    experience?: Experience;
}

interface Payload {
    dates: string[];
    departure: ScheduleDeparture;
    priceDelta: number;
    priceOverride: boolean;
    repeat: BaseScheduleRepeat;
    source: null;
    type: BaseScheduleType;
    timeRanges?: Array<{ startTime: number; endTime: number }>;
}

export const getBlackoutSchedulePayload = ({ timeslot, event, experience }: GetBlackoutSchedulePayloadProps) => {
    const payload: Payload = {
        dates: [timeslot?.date ?? dayjs(event?.actualStart).format("YYYY-MM-DD")],
        departure: ScheduleDeparture.VARIES,
        priceDelta: 0,
        priceOverride: false,
        repeat: BaseScheduleRepeat.CUSTOM,
        source: null,
        type: BaseScheduleType.UNAVAILABLE,
    };

    if (experience) {
        if (event && !isAllDay(event, experience)) {
            payload.timeRanges = getBlackoutTimeRanges(event);
        } else if (!event && !isAllDayExperience(experience) && timeslot) {
            payload.timeRanges = [
                {
                    startTime: Number(formatDate(timeslot.arrivalDatetime ?? event, DateFormat.TIME_SHORT)),
                    endTime: Number(formatDate(timeslot.arrivalDatetime.add(5, "minute"), DateFormat.TIME_SHORT)),
                },
            ];
        }
    }

    return payload;
};
